import { z } from "zod";
import { VOICE_GUESSER_RECORDING_DURATION_MS } from "./game.js";

export const voiceGuesserRecordingSchema = z.object({
	user_id: z.string(),
	audio_id: z.string(),
	uploaded_at: z.number().int().positive(),
	validated_at: z.number().int().positive(),
});

export type VoiceGuesserRecording = z.infer<typeof voiceGuesserRecordingSchema>;

export const submitVoiceGuesserRecordingSchema = z.object({
	audio_url: z.string().min(1),
	duration_ms: z
		.number()
		.int()
		.positive()
		.max(VOICE_GUESSER_RECORDING_DURATION_MS + 2_000),
});

export type SubmitVoiceGuesserRecordingPayload = z.infer<typeof submitVoiceGuesserRecordingSchema>;
